export type { jQuery } from 'jquery';

if (typeof window.jQuery === 'undefined') {
  // eslint-disable-next-line
  const jQuery = require('jquery');
  window.jQuery = jQuery;
  window.$ = jQuery;
}

export default window.jQuery;



// WEBPACK FOOTER //
// ../globals/jquery.js